import React from "react";
import Homecard from "../../Components/card/home-card";

const home = () => {
  return (
    <div>
      <Homecard />
    </div>
  );
};

export default home;
